import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Container } from '@mui/material';
import BoardIDEffects from 'BoardIDEffects';
import { useRecoilValue } from 'recoil';
import { BoardType } from 'Types';

import BoardBase from 'boardClasses/BoardBase';
// import ChevronBuildSteps from 'boardClasses/chevron/ChevronBuildSteps';
import PinwheelBuildSteps from 'boardClasses/pinwheel/PinwheelBuildSteps';
import StripsBuildSteps from 'boardClasses/strips/StripsBuildSteps';
import StripsAdvancedBuildSteps from 'boardClasses/stripsAdvanced/StripsAdvancedBuildSteps';
import ZigZagBuildSteps from 'boardClasses/zigZag/ZigZagBuildSteps';
import { selectedBoardIDAtom } from 'state/recoilState';
import { useSelectedBoardInstance } from 'utils/hooks';
import useRouter from 'utils/useRouter';

export const BUILD_STEPS_COMPONENT_BY_TYPE: Record<
  BoardType,
  null | ((props: { board: BoardBase<any> }) => JSX.Element)
> = {
  [BoardType.Chevron]: null, // ChevronBuildSteps,
  [BoardType.Pinwheel]: PinwheelBuildSteps,
  [BoardType.Plaid]: null,
  [BoardType.QuarterSquare]: null, // QuarterSquareBuildSteps,
  [BoardType.Strips]: StripsBuildSteps,
  [BoardType.StripsAdvanced]: StripsAdvancedBuildSteps,
  [BoardType.Weave]: null,
  [BoardType.ZigZag]: ZigZagBuildSteps,
};

function BuildSteps() {
  const boardID = useRecoilValue(selectedBoardIDAtom);
  const board = useSelectedBoardInstance();

  const { navToBoardID } = useRouter();

  const backToDesigner = () => {
    navToBoardID(boardID);
  };

  const BuildStepsComponent =
    board && BUILD_STEPS_COMPONENT_BY_TYPE[board.type];

  if (BuildStepsComponent == null) {
    return <BoardIDEffects />;
  }

  return (
    <Container maxWidth="md">
      <BoardIDEffects />

      <Box sx={{ pt: 2 }}>
        {board && (
          <Button color="primary" onClick={backToDesigner}>
            <ArrowBackIcon style={{ paddingRight: 4 }} />
            Back to Designer
          </Button>
        )}

        {BuildStepsComponent && board && (
          <BuildStepsComponent board={board}></BuildStepsComponent>
        )}
      </Box>
    </Container>
  );
}

export default BuildSteps;
